
import React, { useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { Check, ArrowLeft } from 'lucide-react';
import Header from '../components/Header';

interface LocationState {
  phoneNumber: string;
}

const ConfirmationFr: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as LocationState;
  
  useEffect(() => {
    // Redirect to home if accessed directly without a phone number
    if (!state || !state.phoneNumber) {
      navigate('/fr');
    }
  }, [state, navigate]);

  if (!state || !state.phoneNumber) {
    return null; // Will redirect via useEffect
  }

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-white to-optout-gray">
      <Header isFrench={true} />
      
      <main className="flex-1 flex flex-col items-center justify-center px-4 py-12">
        <div className="w-full max-w-md mx-auto">
          <div className="glass-card rounded-2xl p-8 animate-fade-in">
            <div className="flex justify-center mb-6">
              <div className="bg-green-100 p-3 rounded-full">
                <Check className="h-6 w-6 text-green-600" />
              </div>
            </div>
            
            <h2 className="text-2xl font-semibold text-center mb-2 text-optout-text">
              Désabonnement Réussi
            </h2>
            
            <p className="text-optout-lighttext text-center mb-6 text-balance">
              Vous vous êtes désabonné avec succès des messages SMS pour :
            </p>
            
            <div className="bg-optout-gray rounded-lg p-4 text-center mb-6">
              <span className="font-medium text-optout-text">{state.phoneNumber}</span>
            </div>
            
            <p className="text-sm text-optout-lighttext text-center mb-6">
              Veuillez prévoir jusqu'à 10 jours ouvrables pour que votre demande soit entièrement traitée.
              Vous pourriez encore recevoir des messages qui ont été programmés avant votre demande de désabonnement.
            </p>
            
            <Link 
              to="/fr"
              className="inline-flex items-center justify-center space-x-2 text-optout-blue hover:text-optout-darkblue transition-colors duration-300 w-full"
            >
              <ArrowLeft className="h-4 w-4" />
              <span>Retour à l'Accueil</span>
            </Link>
          </div>
          
          <div className="text-center mt-8 animate-fade-in" style={{ animationDelay: '200ms' }}>
            <p className="text-sm text-optout-lighttext">
              Si vous avez des questions, veuillez <a href="#contact" className="text-optout-blue hover:underline">nous contacter</a>.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ConfirmationFr;
